import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const notices = [
  {
    id: 1,
    category: '공지',
    title: '2026년 상반기 가맹 설명회 일정 안내',
    date: '2026.03.28',
    important: true,
    content: '2026년 상반기 가맹 설명회가 서울 청담 플래그십 스토어에서 진행됩니다. 참가 신청은 가맹 문의 페이지를 통해 접수해 주세요. 설명회는 매월 첫째 주 토요일 오후 2시에 진행되며, 사전 예약 필수입니다.',
  },
  {
    id: 2,
    category: '공지',
    title: '선율 아카데미 2026년 2기 모집 안내',
    date: '2026.03.20',
    important: true,
    content: '선율 아카데미 2026년 2기 수강생을 모집합니다. 6개월 집중 과정으로 라인워크 전문 아티스트를 양성합니다. 모집 인원은 8명으로 제한되며, 포트폴리오 심사 후 최종 선발됩니다.',
  },
  {
    id: 3,
    category: '업데이트',
    title: '위생 프로토콜 v3.0 업데이트 안내',
    date: '2026.03.15',
    important: false,
    content: '전 가맹점에 적용되는 위생 프로토콜이 v3.0으로 업데이트되었습니다. 주요 변경 사항으로는 멸균 키트 교체 주기 단축 및 신규 소독 장비 도입이 포함됩니다.',
  },
  {
    id: 4,
    category: '이벤트',
    title: '봄 시즌 포트폴리오 이벤트 — 라인워크 특가',
    date: '2026.03.10',
    important: false,
    content: '2026년 봄 시즌을 맞아 라인워크 시술 특가 이벤트를 진행합니다. 4월 한 달간 소형 라인워크 작품 20% 할인 혜택이 제공됩니다. 각 가맹점별 선착순 10명 한정입니다.',
  },
  {
    id: 5,
    category: '공지',
    title: '가맹점 정기 교육 일정 — 2026년 2분기',
    date: '2026.03.05',
    important: false,
    content: '2026년 2분기 가맹점 정기 교육 일정을 안내드립니다. 기술 교육, 위생 교육, 고객 응대 교육이 순차적으로 진행될 예정입니다. 전 가맹점 필수 참석 사항입니다.',
  },
  {
    id: 6,
    category: '업데이트',
    title: '본사 마케팅 지원 시스템 개편 안내',
    date: '2026.02.25',
    important: false,
    content: '본사 마케팅 지원 시스템이 개편되었습니다. SNS 콘텐츠 제작 지원 횟수가 월 4회에서 8회로 확대되었으며, 인스타그램 광고 예산도 가맹점당 월 50만 원으로 증액되었습니다.',
  },
  {
    id: 7,
    category: '공지',
    title: '2025년 연간 가맹점 만족도 조사 결과 발표',
    date: '2026.02.18',
    important: false,
    content: '2025년 연간 가맹점 만족도 조사 결과, 전체 만족도 97%를 기록하였습니다. 특히 본사 지원 시스템과 위생 교육 부문에서 높은 평가를 받았습니다. 상세 결과는 가맹점주 전용 포털에서 확인하실 수 있습니다.',
  },
  {
    id: 8,
    category: '이벤트',
    title: '선율 창립 8주년 기념 고객 감사 이벤트',
    date: '2026.02.10',
    important: false,
    content: '선율 창립 8주년을 맞아 고객 감사 이벤트를 진행합니다. 전국 가맹점에서 시술 고객 대상 기념 굿즈 증정 및 추첨을 통한 무료 시술권 제공 이벤트가 진행됩니다.',
  },
];

const categories = ['전체', '공지', '이벤트', '업데이트'];

const categoryColors: Record<string, string> = {
  '공지': '#1A1A1A',
  '이벤트': '#C9A96E',
  '업데이트': '#888888',
};

function NoticeHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#1A1A1A] overflow-hidden">
      <div className="absolute inset-0 opacity-50">
        <img
          src="https://public.readdy.ai/ai/img_res/d3b1e27a24e4ccabcc439d4a902b481c.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/30 via-transparent to-[#1A1A1A]/60" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-8 md:px-16 text-center">
        <div className="flex items-center justify-center gap-2 mb-10">
          <Link
            to="/community"
            className="text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Community
          </Link>
          <span className="text-white/20 text-xs">/</span>
          <span
            className="text-[10px] tracking-[0.3em] uppercase text-[#C9A96E]"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            공지사항
          </span>
        </div>
        <h1
          className="text-4xl md:text-6xl text-white mb-6 leading-tight"
          style={{ fontFamily: "'Cinzel', serif", fontWeight: 300, letterSpacing: '0.1em' }}
        >
          공지사항
        </h1>
        <p
          className="text-sm text-white/50 leading-relaxed max-w-lg mx-auto"
          style={{ fontFamily: "'Noto Sans KR', sans-serif", lineHeight: '1.8' }}
        >
          선율의 새로운 소식과 중요 안내사항을 확인하세요.
        </p>
        <div className="mx-auto mt-12 h-px bg-white/15" style={{ width: '80px' }} />
      </div>
    </section>
  );
}

function NoticeList() {
  const [activeCategory, setActiveCategory] = useState('전체');
  const [openId, setOpenId] = useState<number | null>(null);

  const filtered = activeCategory === '전체'
    ? notices
    : notices.filter((n) => n.category === activeCategory);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-[1440px] mx-auto px-8 md:px-16">

        {/* Category Filter */}
        <div className="flex items-center gap-2 mb-12 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className="px-5 py-2 text-xs tracking-[0.15em] uppercase transition-all duration-200 cursor-pointer whitespace-nowrap rounded-full"
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                background: activeCategory === cat ? '#1A1A1A' : 'transparent',
                color: activeCategory === cat ? '#FFFFFF' : '#888888',
                border: activeCategory === cat ? '1px solid #1A1A1A' : '1px solid #E5E5E5',
              }}
            >
              {cat}
            </button>
          ))}
          <span
            className="ml-auto text-xs text-[#AAAAAA]"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            총 {filtered.length}건
          </span>
        </div>

        {/* Notice Items */}
        <div className="flex flex-col">
          {filtered.map((notice, i) => (
            <div
              key={notice.id}
              className="border-b border-[#F0F0F0] last:border-b-0"
              style={{ borderTop: i === 0 ? '1px solid #E5E5E5' : 'none' }}
            >
              <button
                className="w-full text-left py-6 flex items-start gap-5 cursor-pointer group"
                onClick={() => setOpenId(openId === notice.id ? null : notice.id)}
              >
                {/* Category badge */}
                <span
                  className="flex-shrink-0 mt-0.5 px-2.5 py-1 text-[10px] tracking-[0.12em] uppercase rounded-full"
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 600,
                    background: `${categoryColors[notice.category]}12`,
                    color: categoryColors[notice.category],
                    border: `1px solid ${categoryColors[notice.category]}30`,
                  }}
                >
                  {notice.category}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    {notice.important && (
                      <span className="w-1.5 h-1.5 rounded-full bg-[#C9A96E] flex-shrink-0" />
                    )}
                    <p
                      className="text-sm font-semibold text-[#1A1A1A] group-hover:text-[#C9A96E] transition-colors duration-200 truncate"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                    >
                      {notice.title}
                    </p>
                  </div>
                  <p
                    className="text-xs text-[#AAAAAA]"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {notice.date}
                  </p>
                </div>

                <i
                  className={`ri-arrow-down-s-line text-[#CCCCCC] flex-shrink-0 mt-0.5 transition-transform duration-300 ${openId === notice.id ? 'rotate-180' : ''}`}
                />
              </button>

              {/* Expanded content */}
              {openId === notice.id && (
                <div
                  className="pb-6 pl-[calc(60px+20px)] pr-8"
                  style={{ borderTop: '1px solid #F5F5F5' }}
                >
                  <p
                    className="text-sm text-[#555] leading-relaxed pt-5"
                    style={{ fontFamily: "'Noto Sans KR', sans-serif", lineHeight: '1.85' }}
                  >
                    {notice.content}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 pt-12 border-t border-[#F0F0F0] flex flex-col sm:flex-row items-center justify-between gap-6">
          <p
            className="text-sm text-[#888]"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            더 궁금한 점이 있으신가요?
          </p>
          <Link
            to="/community/inquiry"
            className="px-8 py-3 bg-[#1A1A1A] text-white text-xs tracking-[0.18em] uppercase font-medium hover:bg-[#333] transition-colors duration-300 cursor-pointer whitespace-nowrap rounded-full"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            가맹 문의하기
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function NoticePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <NoticeHero />
        <NoticeList />
      </main>
      <Footer />
    </div>
  );
}
